import { render, staticRenderFns } from "./BuyCurrencyFactorComponent.vue?vue&type=template&id=ebfc32e6&"
import script from "./BuyCurrencyFactorComponent.vue?vue&type=script&lang=js&"
export * from "./BuyCurrencyFactorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports